import { h } from 'preact';
import { configure } from '../../config';
import style from './style';
import { Text, MarkupText } from 'preact-i18n';

export function PrivacyPolicyWidget ({ partners, clientDisplayName, imdsLink, clientLink }) {

	let intlFields = {
		hostname: window.location.hostname,
		clientDisplayName,
		imdsLink,
		clientLink
	};

	return (
		<div class={style.privacy}>
			<div class={style.title}><Text id="privacyTitle" /></div>
			<div class={style.description}><MarkupText id="privacyUserPrivacy" fields={intlFields} /></div>
			<div class={style.description}><MarkupText id="privacyManaged" fields={intlFields} /></div>
			<div class={style.description}><MarkupText id="privacySharing" fields={intlFields} /></div>
			{ clientLink && <div class={style.description}><MarkupText id="privacyClientPolicy" fields={intlFields} /></div> }
			<div class={style.description}><MarkupText id="privacyImdsPolicy" fields={intlFields} /></div>
			<div class={style.description}><MarkupText id="privacyDataPartners" fields={intlFields} /></div>
			<div class={style.description}><MarkupText id="privacyDoNotSell" fields={intlFields} /></div>
			<div class={style.description}><MarkupText id="privacyAboutOurAds" fields={intlFields} /></div>
			<div class={style.description}><MarkupText id="privacyDataDownload" fields={intlFields} /></div>
		</div>
	);

}


export const PrivacyPolicy = (configure({
	clientDisplayName: 'clientDisplayName',
	imdsLink: 'privacyWidgetsConfig.privacyPolicy.imdsLink',
	clientLink: 'privacyWidgetsConfig.privacyPolicy.clientLink'
})((props) =>  (
	<PrivacyPolicyWidget {...props} />
)));
